import React from 'react'
import MaintenanceYearList from '../../components/maintenanceYearComponents/MaintenanceYearList'
import { useDispatch } from 'react-redux';
import { setHeaderName } from '../../redux/actions/userActions';

const MaintenanceYear = () => {
    const dispatch = useDispatch();
    dispatch(setHeaderName('SET_HEADER_NAME', 'Hospital Masters'));

    return <MaintenanceYearList />
}

export default MaintenanceYear